import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useScrollToTop } from "../../Hooks/useScrollToTop";
import "./ScrollToTop.css";

const ScrollToTop = () => {
  const { isVisible, scrollToTop } = useScrollToTop();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <button
      className={`scroll-to-top ${isVisible ? "visible" : ""}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
      </svg>
    </button>
  );
};

export default ScrollToTop;
